import { Injectable, TemplateRef, inject } from '@angular/core';

import { NgxHmGalleryItem, NgxHmGalleryService } from 'ngx-hm-gallery';
import { Observable } from 'rxjs';

export interface MyGallery {
  open: (currentIndex: number, autoplay?: boolean) => Observable<any>;
}

@Injectable({
  providedIn: 'root',
})
export class MyGalleryService {
  private _gallery = inject(NgxHmGalleryService);
  private itemTemplate: TemplateRef<any>;
  private galleryTemplate: TemplateRef<any>;

  setTemplate(itemTemplate, galleryTemplate) {
    this.itemTemplate = itemTemplate;
    this.galleryTemplate = galleryTemplate;

    return this;
  }

  create(data: NgxHmGalleryItem[]): MyGallery {
    return {
      open: (currentIndex: number, autoplay = false) => {
        return this._gallery.open({
          data,
          itemTemplate: this.itemTemplate,
          galleryTemplate: this.galleryTemplate,
          autoplay,
          currentIndex,
        });
      },
    };
  }
}
